import React from 'react';
import './removeData.css';
import { useDispatch, useSelector } from "react-redux";
import { setRemoveDataFormAction } from "../../redux/rootReducer";
import Checkbox from "../Checkbox/Checkbox";
import { RemoveDataThunk } from "../../redux/thunks/RemoveDataThunk";

const RemoveData = () => {
    const dispatch = useDispatch();
    const remove_data_form = useSelector(state => state.remove_data_form);

    return (
        <div className="page__content">
            <div className="remove">
                <div className="remove__attention">Внимание! Все удалённые данные не подлежат восстановлению!</div>
                <div className="remove__content">
                    <div className="remove__date">
                        <div className="remove__title">Удалить данные до:</div>
                        <input type="date" className="input"
                            value={ remove_data_form.date }
                            onChange={ event => {
                                dispatch(setRemoveDataFormAction({
                                    ...remove_data_form,
                                    date: event.target.value
                                }));
                            }}
                        />
                    </div>

                    <div className="remove__types">
                        <div className="remove__type">
                            <Checkbox
                                active={ remove_data_form.workouts }
                                caption={ 'Тренировки' }
                                handler={ () => {
                                    dispatch(setRemoveDataFormAction({
                                        ...remove_data_form,
                                        workouts: remove_data_form.workouts === 0 ? 1 : 0
                                    }));
                                } }
                            />
                        </div>
                        <div className="remove__type">
                            <Checkbox
                                active={ remove_data_form.subscriptions }
                                caption={ 'Абонементы' }
                                handler={ () => {
                                    dispatch(setRemoveDataFormAction({
                                        ...remove_data_form,
                                        subscriptions: remove_data_form.subscriptions === 0 ? 1 : 0
                                    }));
                                } }
                            />
                        </div>
                        <div className="remove__type">
                            <Checkbox
                                active={ remove_data_form.payments }
                                caption={ 'Платежи' }
                                handler={ () => {
                                    dispatch(setRemoveDataFormAction({
                                        ...remove_data_form,
                                        payments: remove_data_form.payments === 0 ? 1 : 0
                                    }));
                                } }
                            />
                        </div>
                        <div className="remove__type">
                            <Checkbox
                                active={ remove_data_form.booking }
                                caption={ 'Расписание и записи' }
                                handler={ () => {
                                    dispatch(setRemoveDataFormAction({
                                        ...remove_data_form,
                                        booking: remove_data_form.booking === 0 ? 1 : 0
                                    }));
                                } }
                            />
                        </div>
                    </div>

                    <div className="button button--red"
                        onClick={ () => {
                            if (!window.confirm('Вы действительно хотите удалить данные без возможности восстановления?')) return;

                            dispatch(RemoveDataThunk({
                                date: remove_data_form.date,
                                workouts: remove_data_form.workouts,
                                subscriptions: remove_data_form.subscriptions,
                                payments: remove_data_form.payments,
                                booking: remove_data_form.booking
                            }));
                        } }
                    >Удалить</div>
                </div>
            </div>
        </div>
    );
};

export default RemoveData;